import { TMassPostSaleJobOrder } from 'redux/reducers/massPostSaleJobs/types';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import {
	MASS_POST_SALE_JOB_ORDER_PROCESSING_TYPE_FILTER,
	MASS_POST_SALE_JOB_ORDER_STATUS_COLORS,
	MASS_POST_SALE_JOB_ORDER_STATUS_FILTER,
} from '../constants';

export const tableStructure: TTableStructure<keyof TMassPostSaleJobOrder>[] = [
	{
		selector: 'id',
		name: 'Id',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		key: true,
	},
	{
		selector: 'jobId',
		name: 'Job ID',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'orderId',
		name: 'EAS Order ID',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: false,
		type: ETableStructureType.ORDER_ID,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'externalOrderId',
		name: 'External Order ID',
		show: true,
		sortable: true,
		filterable: false,
		searchable: false,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'timestampYear',
		name: 'Year',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'processingType',
		name: 'Processing Type',
		show: false,
		sortable: true,
		// Always pinned to the `:processingType` route param, so it is not filterable here.
		filterable: false,
		filter: MASS_POST_SALE_JOB_ORDER_PROCESSING_TYPE_FILTER,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'status',
		name: 'Status',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		filter: MASS_POST_SALE_JOB_ORDER_STATUS_FILTER,
		colors: MASS_POST_SALE_JOB_ORDER_STATUS_COLORS,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'errMessage',
		name: 'Error Message',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'warningMessage',
		name: 'Warning Message',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
];
